import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=4bb3b3fe&scoped=true"
import script from "./Offers.vue?vue&type=script&lang=ts"
export * from "./Offers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3b3fe",
  null
  
)

export default component.exports